import { compose } from "redux"
import SummaryPage from "../components/summary-page"
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { QUESTIONNAIRE_FRAGMENT, SURVEY_LIST_PARAMETER_FRAGMENT, SURVEY_TREE_PARAMETER_FRAGMENT } from "../graphql/fragments"
import { setSubmitError, setFilters } from '../actions/survey'
import { connect } from 'react-redux'
import { YOU_FILTER, toNormalizedRespondentFilters } from '../utilities/helpers'
import { withImprovementProjectData } from './withImprovementProjectData'

const paramsQuery = gql`
  query FinishPageParams(
    $surveyId: UUID!
    $languageCode: String
  ) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
    respondentParameters(
      surveyId: $surveyId
      languageCode: $languageCode
    ) {
      ...SurveyListParameter
      ...SurveyTreeParameter
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
  ${SURVEY_LIST_PARAMETER_FRAGMENT}
  ${SURVEY_TREE_PARAMETER_FRAGMENT}
`;

const query = gql`
  query FinishPage(
    $surveyId: UUID!,
    $respondentFilters: [RespondentFilterInput!],
    $languageCode: String
  ) {
    surveyStatistics(
      surveyId: $surveyId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      __typename
      ... on SurveyStatisticsOutput {
        overallAggregatedResponse,
        themes {
          id
          aggregatedResponse
        }
        drivers {
          id
          aggregatedResponse
          aggregatedImportance
        }
        questions {
          id
          aggregatedResponse
          aggregatedImportance
          totalRespondentCount
          skippedRespondentCount
        }
      }
    }
    afterGameRespondentCountOverview(
      surveyId: $surveyId
    ) {
      answeredRespondentCount
      invitedRespondentCount
      engagementPercentage
    }
  }
`;

const mapStateToProps = ({ survey: { filters, submitError } }) => {
  return {
    filters,
    submitError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetFilters: filters => {
      dispatch(setFilters(filters))
    },
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    }
  };
};

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps),
  withData(paramsQuery, {
    options: (props) => {
      return {
        ...getVariables(props),
        fetchPolicy: "network-only",
      };
    },
  }),
  withData(query, {
    options: (props) => {
      const variables = { ...getVariables(props) }

      if (props.questionnaire.isAfterGameGuest || props.questionnaire.canViewAfterGame) {
        // Aftergame
        props.onSetFilters(props.filters ? props.filters : []);
        variables.variables.respondentFilters = toNormalizedRespondentFilters(props.filters);
      } else {
        // Before aftergame always "You" filter
        props.onSetFilters(YOU_FILTER);
        variables.variables.respondentFilters = YOU_FILTER;
      }

      return {
        ...variables,
        fetchPolicy: "network-only",
      };
    },
  }),
  withImprovementProjectData,
)(SummaryPage)



// WEBPACK FOOTER //
// ./src/containers/summary-page.js